var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose"},_vm._l((_vm.chooseArr),function(item,index){return _c('div',{key:index,staticClass:"item",class:{ ischose: _vm.choosenum == index },on:{"click":function($event){return _vm.clickChoose(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }